import KroTabBar, {
  createTabController,
} from "features/components/tab/kroTabBar";
import { getSessionUser } from "common/store/useAuthStore";
import { FC } from "react";
import KroLoadingIndicator, {
  LoaderType,
} from "features/components/loader/kroCircularIndicator";
import useFetchUSerDashboardStatistics from "../../hooks/useFetchUserDashboardStatistics";
import useFetchUserCampaigns from "../../hooks/useFetchUserCampaigns";
import { toast } from "react-toastify";
import EmptyCampaignCard from "./EmptyCampaignCard";
import DashboardCampaignCard from "./dashboardCampaignCard";

export enum MyCampaignsTabs {
  closedCampaigns = "Closed Campaigns",
  drafts = "Drafts",
  activeCampaigns = "Active Campaigns",
  inReviewCampaigns = "Campaigns in Review",
}

const MyCampaigns: FC = function MyCampaigns() {
  // const navigate = useNavigate();


  // const { showActionSnackbar } = useSnackbar();
  const user = getSessionUser();
  const tabController = createTabController();

  const {
    isLoading: isLoadingUserDashboardStatistics,
    dashboardStatistics,
    refetch: refetchUserDashboardStatistics,
    error: errorLoadingUserDashboardStatistics
  } = useFetchUSerDashboardStatistics();


  const {
    isLoading: isLoadingUsersCampaigns,
    campaigns: usersCampaigns,
    refetch: refetchUsersCampaigns,
    error: errorLoadingCampaigns
  } = useFetchUserCampaigns(user?.slug ?? "");

  if (isLoadingUsersCampaigns || isLoadingUserDashboardStatistics) {
    return <KroLoadingIndicator type={LoaderType.FIXED} />;
  }

  if (errorLoadingUserDashboardStatistics) {
    toast.error(
      ({ closeToast }) => (
        <div className="flex items-center justify-between gap-2">
          <span>{errorLoadingUserDashboardStatistics?.message}</span>
          <span
            onClick={() => {
              refetchUserDashboardStatistics();
              closeToast();
            }}
            className="text-sm cursor-pointer text-black underline hover:text-gray-700"
          >
            Reload
          </span>
        </div>
      ),
      {
        autoClose: false,
        closeOnClick: false
      }
    );
  }

  if (errorLoadingCampaigns) {
    toast.error(
      ({ closeToast }) => (
        <div className="flex items-center justify-between gap-2">
          <span>{errorLoadingCampaigns.message}</span>
          <span
            onClick={() => {
              refetchUsersCampaigns();
              closeToast();
            }}
            className="text-sm cursor-pointer text-black underline hover:text-gray-700"
          >
            Reload
          </span>
        </div>
      ),
      {
        autoClose: false,
        closeOnClick: false
      }
    );
  }

  return (
    <div className="mt-[48px] w-full">
      <div className="mx-[20px]">
        <KroTabBar tabController={tabController} tabs={[
          {
            name: MyCampaignsTabs.activeCampaigns,
            label: "Active Campaigns",
            component: <div className="flex flex-col lg:gap-[48px] gap-[24px]">
              {usersCampaigns?.reverse().filter((campaign => campaign.status === "published")).length === 0 ?
                <EmptyCampaignCard /> :
                usersCampaigns?.reverse().filter((campaign => campaign.status === "published" || campaign.status === "in_review")).map((campaign, index) =>
                  <DashboardCampaignCard campaign={campaign} />
                )}
            </div>,
            badge: dashboardStatistics?.activeCampaignCount
          },
          {
            name: MyCampaignsTabs.closedCampaigns,
            label: "Closed Campaigns",
            component: <div className="flex flex-col lg:gap-[48px] gap-[24px]">
              {usersCampaigns?.reverse().filter((campaign => campaign.status === "ended")).length === 0 ?
                <EmptyCampaignCard /> :
                usersCampaigns?.reverse().filter((campaign => campaign.status === "ended")).map((campaign, index) =>
                  <DashboardCampaignCard campaign={campaign} />)}
            </div>,
            badge: usersCampaigns?.filter((campaign) => campaign.status === "ended").length
          },
          {
            name: MyCampaignsTabs.drafts,
            label: "Drafts",
            component: <div className="flex flex-col lg:gap-[48px] gap-[24px]">
              {usersCampaigns?.reverse().filter((campaign => campaign.status === "draft")).length === 0 ?
                <EmptyCampaignCard /> :
                usersCampaigns?.reverse().filter((campaign => campaign.status === "draft")).map((campaign, index) =>
                  <DashboardCampaignCard campaign={campaign} />)}
            </div>,
            badge: usersCampaigns?.filter((campaign) => campaign.status === "draft").length
          },
          {
            name: MyCampaignsTabs.inReviewCampaigns,
            label: "Campaigns in Review",
            component: <div className="flex flex-col lg:gap-[48px] gap-[24px]">
              {usersCampaigns?.reverse().filter((campaign => campaign.status === "in_review")).length === 0 ?
                <EmptyCampaignCard /> :
                usersCampaigns?.reverse().filter((campaign => campaign.status === "in_review")).map((campaign, index) =>
                  <DashboardCampaignCard campaign={campaign} />)}
            </div>,
            badge: usersCampaigns?.filter((campaign) => campaign.status === "in_review").length
          }
        ]} />
      </div>
    </div>
  );
};




export default MyCampaigns;
